import { ResponsiveComponentProps, ResponsiveWrapper } from '../ResponsiveWrapper';
import { EChart, EChartsProps } from './EChart';

export type ResponsiveEChartProps<SeriesData> = ResponsiveComponentProps<EChartsProps<SeriesData>>;

export function ResponsiveEChart<SeriesData>({
  width: overrideWidth,
  height: overrideHeight,
  ...componentProps
}: ResponsiveEChartProps<SeriesData>) {
  return (
    <ResponsiveWrapper height={overrideWidth} width={overrideHeight}>
      {({ width, height }) => {
        return <EChart width={width} height={height} {...componentProps} />;
      }}
    </ResponsiveWrapper>
  );
}
